export const apiConstants = {
    apiRedirectPath: "/sign-in",
    sessionExpiredMessage: "Your session has expired. Please sign in again.",
    contentType: {
        JSON: `application/json`,
        MULTI: `multipart/form-data`
    },
    successMessage: {
        GENERIC: `Success`,
        approval: {
            APPROVAL_UPDATED: `Successfully updated the approval status.`
        },
        catalog: {
            CATALOG_ITEM_ADDED: `Successfully added a new item to the catalog.`,
            CATALOG_ITEM_UPDATED: `Successfully updated the item in the catalog.`,
            CATALOG_VENDOR_ADDED: `Successfully added a new vendor to the catalog.`,
            CATALOG_VENDOR_UPDATED: `Successfully updated the vendor in the catalog.`,
            CATALOG_PUBLISHER_ADDED: `Successfully added a new publisher to the catalog.`,
            CATALOG_PUBLISHER_UPDATED: `Successfully updated the publisher in the catalog.`,
            CATALOG_AVAILABILITY_UPDATED: `Successfully updated the availability status.`,
        },
        loanLibrary: {
            CATALOG_ITEM_ADDED: `Loan Library catalog item added successfully.`,
            CATALOG_ITEM_UPDATED: `Loan Library catalog item updated successfully.`,
            CATALOG_ITEM_DELETED: `Loan Library catalog item deleted successfully.`,
            INVENTORY_ITEM_ADDED: `Inventory item added successfully.`,
            INVENTORY_ITEM_UPDATED: `Inventory item updated successfully.`,
            INVENTORY_ITEM_DELETED: `Inventory item deleted successfully.`,
            LOAN_UPDATED: `Loan updated successfully.`,
            ITEM_RETURNED: `Item returned successfully.`,
            LOAN_RENEWED: `Loan renewed successfully.`,
            MANUFACTURER_ADDED: `Successfully added a new manufacturer to the catalog.`,
            MANUFACTURER_UPDATED: `Successfully updated the manufacturer in the catalog.`,
        },
        queue: {
            ADD: `Successfully added item to your Queue.`,
            DELETE: `Successfully removed an item from your Queue.`,
            UPDATE: `Successfully updated items from your Queue.`
        },
        loan: {
            PROCESS: "You have successfully marked an item as "
        },
        checkIn:{
            CHECKIN: "You have successfully checked in the item."
        },
        accessNumberSearch:{
            FOUND: "Volumes found."
        },
        order: {
            ADD: `Successfully added a order request.` ,
            CANCEL: `The order has been canceled successfully.`,
            PLACE_AN_ORDER: `Successfully updated the order.` ,
            RECEIVED_ORDER: `Successfully received the order.`,
            FULFILL_ORDER: `Successfully fulfilled the order.`,
            REVERT_FROM_COMPLETE: `Successfully reverted order status. You may now continue processing.`,
        },
        shippingLocation: {
            ADD: `Successfully added a shipping location.`,
            DELETE: `Successfully removed the shipping location.`,
            EDIT: `Successfully updated the shipping location.`
        },
        report : {
            REPORT_DOWNLOADED: `The report has been successfully downloaded.`
        },
        ownLoan: {
            UPDATE: `Owned item updated successfully.`
        },
        user: {
            REGISTER: `Your registration has been successfully submitted and is now pending approval. Once you are approved, you will be notified via email.`,
            LOGOUT: `You have successfully signed out.`,
            REGISTER_WITH_INVALID_EMAIL: `You have successfully registered but there was an issue sending your confirmation email.  Please update your email address in your profile or contact tech support for help.`,
            FORGOT_PASSWORD: `Email sent. Check your inbox for further instructions.`,
            UPDATE_PASSWORD: `Your password has been successfully updated.`,
            UPDATE: `Successfully updated the user.`
        }
    },
    errorMessage: {
        GENERIC: `Error`,
        user: {
            REGISTER: `There was an issue registering.  Please try again.`,
            REGISTER_WITH_INVALID_EMAIL: 'There was an error while attempting to send email.',
            REGISTER_WITH_PASSWORD_MISMATCH: 'Password must match confirmation field.',
            FORGOT_PASSWORD: `There was an issue sending the email.  Please try again.`,
            FORGOT_PASSWORD_INVALID_EMAIL: 'There was an error while attempting to send email.',
            UPDATE_PASSWORD: `There was an issue updating your password.  Please try again.`,
        }

    }
};